import $ from 'jquery';
import { Component, AfterContentInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';

export interface IAccordionEvent {
  name: string;
  isOpen: boolean;
}

const ANIMATION_DURATION_MS = 400;

@Component({
  selector: 'accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements AfterContentInit {
  @Input() public openOneElementAtATime: boolean;
  @Output() public onChange: EventEmitter<IAccordionEvent> = new EventEmitter();
  private el: HTMLElement;
  private $el: any;
  private $accordion: any;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
    this.$el = $(this.el);
  }

  public ngAfterContentInit() {
    const that = this;
    const options = {
      animateChildren: false,
      duration: ANIMATION_DURATION_MS,
      exclusive: this.openOneElementAtATime,
      onOpening() {
        that.handleChange(this.attr('data-key'), true);
      },
      onClosing() {
        that.handleChange(this.attr('data-key'), false);
      },
    };
    this.$accordion = this.$el.find('.ui.accordion');
    this.$accordion.accordion(options);
  }

  private handleChange(name: string, isOpen: boolean) {
    this.onChange.emit({
      name,
      isOpen,
    });
  }
}
